/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { PromptControllerFindPromptRewardByIDQueryResponse, PromptControllerFindPromptRewardByIDPathParams, PromptControllerFindPromptRewardByID400, PromptControllerFindPromptRewardByID401, PromptControllerFindPromptRewardByID404, PromptControllerFindPromptRewardByID409, PromptControllerFindPromptRewardByID500 } from "../types/PromptControllerFindPromptRewardByID.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getPromptControllerFindPromptRewardByIDUrl(promptRewardID: PromptControllerFindPromptRewardByIDPathParams["promptRewardID"]) {
  const res = { method: 'GET', url: `/api/prompt/${promptRewardID}` as const }
  return res
}

/**
 * @description Retrieves the prompt reward details corresponding to the specified prompt reward ID. Access is restricted based on the resource's scope and the user's permissions.
 * @summary Get Prompt Reward by ID
 * {@link /api/prompt/:promptRewardID}
 */
export async function promptControllerFindPromptRewardByID(promptRewardID: PromptControllerFindPromptRewardByIDPathParams["promptRewardID"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PromptControllerFindPromptRewardByIDQueryResponse, ResponseErrorConfig<PromptControllerFindPromptRewardByID400 | PromptControllerFindPromptRewardByID401 | PromptControllerFindPromptRewardByID404 | PromptControllerFindPromptRewardByID409 | PromptControllerFindPromptRewardByID500>, unknown>({ method : "GET", url : getPromptControllerFindPromptRewardByIDUrl(promptRewardID).url.toString(), ... requestConfig })
  return res.data
}